import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const featuredComic = comics[11];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[90vh] flex items-center">
      <div className="absolute inset-0 mx-5 my-4 md:mx-7 md:my-5 rounded-[24px] md:rounded-[32px] overflow-hidden">
        <img
          src={featuredComic.cover}
          alt={featuredComic.title}
          className="w-full h-full object-cover object-top"
          title={featuredComic.title + ' - 韩漫屋热门推荐'}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-6 pt-20 pb-10">
        <div className="inline-flex items-center gap-2 px-5 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm mb-7">
          <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse"></span>
          <span className="text-xs font-medium text-white tracking-wide">本周强推</span>
        </div>

        <h1 className="text-4xl md:text-7xl font-bold font-[family-name:var(--font-heading)] text-white leading-tight max-w-3xl">
          {featuredComic.title}
        </h1>

        <p className="mt-5 text-sm md:text-base text-white/70 font-light max-w-xl tracking-wide">
          作者：{featuredComic.author}  ·  已更新至 {featuredComic.latestChapter}  ·  评分 {featuredComic.rating}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
          <Link
            to={`/comic/${featuredComic.slug}`}
            className="px-8 py-3 bg-white text-stone-800 rounded-full text-sm font-medium hover:bg-stone-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/langman-aiqing"
            className="px-8 py-3 border border-white/40 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            探索更多
          </Link>
        </div>

        <div className="mt-16 flex items-center gap-8 text-white/50 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-eye-line"></i> {(featuredComic.views / 10000).toFixed(0)}万阅读
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-star-fill text-yellow-400"></i> {featuredComic.rating}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line"></i> {featuredComic.updateDate}
          </span>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}